import styled from "styled-components";

const PaddingContent = styled.div<{ tab?: boolean }>`
  /* padding: 24px;
  width: 100%;
  height: 100%; */
  position: relative;
  width: 100%;
  box-sizing: border-box;
  height: ${({ tab }) => `calc(100vh - 57px ${tab ? "- 56px" : ""})`};
  overflow: auto;
  padding: 22px 24px;
`;

export { PaddingContent };
